import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link } from "react-router-dom";

export const BreadcrumbSkeleton = ({ leading }) => {
  const skeletonNav = (
    <nav aria-label="breadcrumb">
      <ol
        className="breadcrumb"
        style={{ display: "flex", gap: "10px" }}
      >
        <li className="breadcrumb-item">
          <Link to="/home">Home</Link>
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          <Skeleton width={100} height={16} />
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          <Skeleton width={100} height={16} />
        </li>
      </ol>
    </nav>
  );

  return (
    <section className="breadcrumb-section">
      <div className="container-fluid container-lg">
        <div className="row">
          <div className="col-lg-12">
            {leading ? (
              <div className="breadcrumb-with-back">
                {leading}
                {skeletonNav}
              </div>
            ) : (
              skeletonNav
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
